import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'State',
      fields: {
        delivery_visible: {
          label: 'Delivery visible',
        },
        has_delivery: {
          label: 'Delivery',
        },
        delivery_enabled: {
          label: 'Delivery live',
        },
      },
    },
    delivery_mode: {
      title: 'Delivery mode',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Restaurant drivers fleet',
            [DeliveryMode.External]: 'External drivers fleet ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Driver pickup note',
          placeholder: 'Extra useful pickup information for the driver (e.g. how to find the entrance, etc.)',
        },
        instant_print_enabled: {
          label: 'Print ticket without waiting for driver',
        },
        provider_not_connected: {
          wolt_drive: 'Not connected yet: this restaurant has no valid Wolt venue ID.',
          connects_on_external: '{{provider}} is connected once Delivery mode is set to external drivers and saved.',
          not_connected_yet:
            '{{provider}} is not connected for this restaurant yet. If this does not change, please contact support.',
        },
      },
    },
    scheduled_orders: {
      title: 'Scheduled orders',
      fields: {
        has_scheduled_orders: {
          label: 'Do you allow your customers to order ahead for specific times?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Minimum time (minutes) in advance for scheduling <strong>delivery</strong> orders',
          placeholder: '60',
          validation_name: 'Minimum delivery scheduling time',
          external_hint: 'With external delivery, this must be at least {{minutes}} minutes (2 hours). ',
        },
        last_order_gap_delivery: {
          label: 'Last possible time to order for <strong>delivery</strong> (minutes before closing time)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Delivery Info',
      fields: {
        average_order_delivery_time_min: {
          label: 'Delivery time',
          placeholder: 'Time in minutes',
        },
        average_order_delivery_time_max: {
          label: 'till',
          placeholder: 'Optional',
        },
      },
    },
    delivery_zones: {
      title: 'Delivery zones',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    at_least_one_order_method_required:
      "At least 1 order method (scheduled or asap) needs to be turned on. You can't disable both.",
  },
};
